import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { InfoIcon } from "lucide-react";

export function DepositAlert() {
  return (
    <div className="px-6">
      <Alert className="my-4 border-zinc-800 bg-zinc-900/50">
        <InfoIcon className="h-5 w-5 text-blue-400" />
        <AlertTitle className="mb-2 font-medium text-zinc-100">
          Deposit Payment Information
        </AlertTitle>
        <AlertDescription className="text-sm leading-relaxed text-zinc-300">
          The price shown is a non-refundable deposit per service, not the full
          price. This deposit will be deducted from your final payment when you
          arrive for your appointment. The remaining balance is to be paid in
          person.
        </AlertDescription>
      </Alert>
    </div>
  );
}
